import setLang from '../lang';

const lang = {
    i: {
        locale: 'es-ES',

    }
};

setLang(lang);

export default lang;



// WEBPACK FOOTER //
// ./goingsrc/locale/lang/es-ES.js